import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  palette: {
    primary: {
      main: "#FC3468",
    },
    secondary: {
      main: "#db0007",
    },
    accent: {
      main: "#FC3468",
    },
    background: {
      header: {
        gradient: "linear-gradient(180deg, #382A5D 0%, #140930 100%)",
      },
      admin: {
        gradient: "radial-gradient(circle at center, #32353B 0%, #1F2226 50%)",
      },
      customer: {
        gradient: "radial-gradient(circle at center, #382A5D 0%, #140930 50%)",
      },
      homepage: {
        gradient:
          "radial-gradient(circle at left bottom, #382A5D 0%, #140930 40%)",
      },
      secondary: "#E0E3E8",
      footer: "#1E133B",
    },
    button: {
      background: {
        secondary: "#EAECF0",
      },
    },
    text: {
      primary: "#474B52",
      secondary: "#B1B6BF",
      inverse: "#E0E3E8",
      dark: "#474B52",
      title: "#292929",
      caption: "#4B4B4B",
      subcaption: "#6D7075",
      heading: "#32353B",
      link: {
        admin: "#378ED1",
      },
      menu: { primary: "#414651", heading: "#181D27", subtext: "#535862" },
    },
    error: {
      background: {
        alert: "#202020",
      },
      main: "#FC3468",
      border: "#DD1E1E",
    },
    tooltip: {
      primary: "#0a0d12",
    },
  },
  typography: {
    fontFamily: "Acari Sans, sans-serif",
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        maxWidthLg: {
          maxWidth: "1216px",
          "@media (min-width:1200px)": {
            maxWidth: "1216px",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
            maxHeight: "40px",
            "& fieldset": { borderColor: "#ddd" },
            "&:hover fieldset": { borderColor: "#aaa" },
            "&.Mui-focused fieldset": { borderColor: "#140930" },
          },
          "& input": {
            color: "#000",
            padding: "14px 16px",
            "&::placeholder": {
              fontWeight: 500,
              color: "#B1B6BF",
              opacity: 1,
            },
          },
          "& .MuiFormHelperText-root": {
            color: "#FC3468",
            marginLeft: 0,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "16px",
          borderRadius: "8px",
        },
      },
    },
  },
})

export default theme
